import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { PortfolioChartsComponent } from './portfolio-charts/portfolio-charts.component';
import { PortfolioEntryComponent } from './portfolio-entry/portfolio-entry.component';
import { PortfolioService } from './portfolio.service';
import { SectorBreakdownComponent } from './sector-breakdown/sector-breakdown.component';

/**
 * Module for Portfolio components
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    HighchartsChartModule,
    RouterModule,
    SharedModule,
  ],
  declarations: [
    PortfolioChartsComponent,
    PortfolioEntryComponent,
    SectorBreakdownComponent,
  ],
  entryComponents: [PortfolioEntryComponent],
  providers: [PortfolioService],
})
export class PortfolioModule {
  constructor() {}
}

export const portfolioModuleComponentMapping = {
  'Fund Portfolio': PortfolioEntryComponent,
};
